module.exports = __webpack_public_path__ + "static/media/smokey-bbq-hero-desktop.998ca4de.jpg";